import WebUpdateOnLaunch from './WebUpdateOnLaunch'
import WebUpdateOnStateChange from './WebUpdateOnStateChange'

const UpdateOnLaunch = ({ children }) => <WebUpdateOnLaunch>{children}</WebUpdateOnLaunch>
const UpdateOnStateChange = () => <WebUpdateOnStateChange />

export { UpdateOnLaunch, UpdateOnStateChange }
